import { ReactNode } from 'react'
import clsx from 'clsx'

type PanelRadioItem = {
  id: string
  disabled?: boolean
  testId?: string
}

type PanelRadioGroupProps<T extends PanelRadioItem> = {
  items: T[]
  selectedId: string | null | undefined
  onSelect: (id: string) => void
  ariaLabel: string
  className: string
  itemClassName: string
  selectedClassName: string
  renderItem: (item: T) => ReactNode
}

/** The single-choice radiogroup behind the panel's option lists and tiles */
export default function PanelRadioGroup<T extends PanelRadioItem>({
  items,
  selectedId,
  onSelect,
  ariaLabel,
  className,
  itemClassName,
  selectedClassName,
  renderItem,
}: PanelRadioGroupProps<T>) {
  return (
    <div className={className} role="radiogroup" aria-label={ariaLabel}>
      {items.map(item => {
        const isSelected = item.id === selectedId

        return (
          <button
            key={item.id}
            type="button"
            role="radio"
            aria-checked={isSelected}
            className={clsx(itemClassName, {
              [selectedClassName]: isSelected,
            })}
            disabled={item.disabled}
            data-testid={item.testId}
            onClick={() => onSelect(item.id)}
          >
            {renderItem(item)}
          </button>
        )
      })}
    </div>
  )
}
